<template>
  <div class="loginPage bg">
    <div class="container-fluid p-h-0 p-v-20 full-height d-flex">
      <div class="d-flex flex-column justify-content-between w-100">
        <div class="container d-flex justify-content-center h-100">
          <div class="row align-items-center w-100">
            <div class="col-md-8 col-lg-6 col-lg-5 m-h-auto">
              <div class="card shadow-lg">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-center m-b-30"
                  >
                    <img
                      class="logo"
                      alt=""
                      src="@/assets/images/logo/osu.svg"
                    />
                    <h2 class="isSignin m-b-0 mt-3">
                      Авторизация
                    </h2>
                  </div>
                  <form action="#" @submit.prevent="formSubmit">
                    <div class="form-group">
                      <label class="font-weight-semibold" for="userName"
                        >Email:</label
                      >
                      <div class="input-affix">
                        <i class="prefix-icon anticon anticon-mail"></i>
                        <input
                          type="email"
                          class="form-control"
                          id="userName"
                          placeholder="Email"
                          v-model="user.email"
                          @input="errro401 = false"
                          ref="email"
                          required
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="font-weight-semibold" for="password"
                        >Пароль:</label
                      >
                      <!-- <a class="float-right font-size-13 text-muted" href="">Forget Password?</a> -->
                      <div class="input-affix m-b-10">
                        <i class="prefix-icon anticon anticon-lock"></i>
                        <input
                          type="password"
                          class="form-control"
                          id="password"
                          placeholder="*****"
                          v-model="user.password"
                          @input="errro401 = false"
                          required
                        />
                      </div>
                    </div>
                    <p v-if="error401" class="error401">{{error401.title}}</p>
                    <div class="form-group">
                      <div class="d-flex align-items-center justify-content-center">  
                        <button type="reset" class="btn btn-secondary mr-3">
                          Отмена
                        </button>
                        <button type="submit" class="btn btn-primary">
                          Подтвердитьь
                        </button>       
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'Login',
  data() {
    return {
      error401: {
        title: '',
        status: false
      },
      mode: "signIn",
      user: {
        email: "",
        password: "",
      },
      errors: [],
    };
  },
  computed: {
  },
  methods: {
    ...mapActions("user", ["setUser"]),
    formSubmit() {
      this.signIn();
    },
    async signIn() {
      try {
        const data = (
          await this.$api.auth.signIn({
            email: this.user.email,
            password: this.user.password,
          })
        ).data;

        if (data.user.status_user>1 && data.user.roles.length>0){
          this.$api.instance.defaults.headers.common["Authorization"] = "Bearer " + data.token;
          localStorage.setItem("user", JSON.stringify(data));
          this.setUser(data);
          this.$router.push("/main");
        } else this.noAccess('У вас нету доступа, обратитесь к администратору')
        
      } catch (error) {
        if(error.response.data == 'Unauthenticated login' || error.response.status == 401){
          this.noAccess('Логин или пароль не верны!')
        }
      }
    },
    noAccess(text){
      this.error401.status = true;
      this.error401.title = text;
      this.user.email = ''
      this.user.password = ''
      this.$refs.email.focus()
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.isSignin {
  color: #004fc5;
}
.error401{
  color: red;
  text-align: center;
}
</style>
